import React from 'react';
import { CircleHelp } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { useTranslation } from '@/components/utils/translations';

export default function MarketHelpLabel({ label, hint, className = '' }) {
  const { t } = useTranslation();
  if (!hint) return <span className={className}>{label}</span>;
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span>{label}</span>
      <Popover>
        <PopoverTrigger asChild>
          <button
            type="button"
            className="inline-flex text-[#5C6B7A] hover:text-[#0A1A2F]"
            aria-label={t('mktAboutLabel', { label })}
            onClick={(e) => e.stopPropagation()}
          >
            <CircleHelp className="w-3.5 h-3.5" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-64 text-xs text-[#0A1A2F] leading-relaxed whitespace-pre-wrap" align="start">
          {hint}
        </PopoverContent>
      </Popover>
    </span>
  );
}

export function MarketHelpButton({ label, hint, children }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        {children || (
          <button type="button" className="inline-flex text-[#5C6B7A]" aria-label={label}>
            <CircleHelp className="w-3.5 h-3.5" />
          </button>
        )}
      </PopoverTrigger>
      <PopoverContent className="w-72 text-xs text-[#0A1A2F] leading-relaxed whitespace-pre-wrap">
        {hint}
      </PopoverContent>
    </Popover>
  );
}
